// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"CartItem_cart-item__6sDPY","summary":"CartItem_summary__3XWqF","price":"CartItem_price__1pzXj","amount":"CartItem_amount__2GaJn","actions":"CartItem_actions__3jveX"};